import React, { useEffect, useState } from 'react';
import "./ImportInstitutionCategory.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import { toast } from 'react-toastify';
import { downloadCategoryInstitutionFile, getInstitutionCategories, uploadCategoriesInstitutionFile } from '../../services/http';
import ImportContent from '../../components/ImportContent/ImportContent';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';


const ImportInstitutionCategory = () => {


        const navigate = useNavigate()
        const dispatch = useDispatch();
        const states = useSelector((state) => state, shallowEqual);

        const [isFilePicked, setIsFilePicked] = useState(false);
        const [showError, setShowError] = useState(false)
    const [processOngoing, setProcessOngoing] = useState(false)


        // To populate the breadcrumb and update the sidebar menu
        useEffect(() => {
                dispatch({
                        type: "SET",
                        key: "breadcrumbContent",
                        payload: {
                                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Catégorie d'institution", secondLevelLink: "/institution-category", thirdLevelText: "Import", thirdLevelLink: "/import-institution-catgeory"
                        }
                });

                handleMenuSelection("settings", dispatch, states);
                handleSubMenuSelection("institutions-categories", dispatch)
        }, [])


        const handleImportData = async () => {
                setProcessOngoing(true)
                if (states.selectedFile != null) {
                        const req = await uploadCategoriesInstitutionFile(states.selectedFile, states.userToken.access_token)
                        if (req.response && req.response.status !== 200) {
                                setProcessOngoing(false)
                                if (req.response && req.response.status == 422) {
                                    var errorMsg = `Import partiellement effectué. Les lignes ${Object.keys(req.response?.data)} sont incorrectes.`;
                                    toast.warning(errorMsg, {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                    let response = await getInstitutionCategories(states.userToken.access_token, 1, "");
                
                                    let response_copy = response.data?.data.map(obj => ({ ...obj, showDelete: false }))
                
                                    dispatch({
                                        type: "SET",
                                        key: "institutionCategoriesList",
                                        payload: response_copy,
                                    });
                                } else if(req.response && req.response.status == 400) {
                                        setProcessOngoing(false)
                                    toast.error(req.response?.data, {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                } else {
                                        setProcessOngoing(false)
                                    toast.error(req.response?.data?.message, {
                                        position: toast.POSITION.TOP_RIGHT
                                    });
                                }
                            } else if(req.status == 200) {
                                setProcessOngoing(false)
                                toast.success(req?.data, {
                                    position: toast.POSITION.TOP_RIGHT
                                });
                                let response = await getInstitutionCategories(states.userToken.access_token, 1, "");
                
                                let response_copy = response.data?.data.map(obj => ({ ...obj, showDelete: false }))
                
                                dispatch({
                                    type: "SET",
                                    key: "institutionCategoriesList",
                                    payload: response_copy,
                                });
                
                            }
                } else {
                        setProcessOngoing(false)
                        toast.warning(`Veuillez sélectionner un fichier`, {
                                position: toast.POSITION.TOP_RIGHT
                        });
                }
        }

        return (
                <div>
                        <Navbar />
                        <div className="main-container" id="container">
                                <Sidebar />

                                <div id="content" className="main-content">
                                        <div className="layout-px-spacing">

                                                <div className="row layout-top-spacing">
                                                        <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                                        </div>
                                                </div>                        <div className="row pl-3 mt-2">
                                                        <button className="btn btn-rounded mb-2 mr-2" onClick={() => { navigate("/institution-category") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
                                                </div>
                                                <ImportContent processOngoing={processOngoing} downloadRequest={downloadCategoryInstitutionFile} fileName={"catégories institutions"} type={" catégories d'institutions "} handleImportData={handleImportData} />
                                        </div>

                                </div>
                        </div>
                </div>
        )
}

export default ImportInstitutionCategory